import Seo from "../components/Seo";
import { Card, CardContent } from "../components/ui/card";
import { SEO_ROUTE_PROPS } from "../seo/metadata";

const SUPPORT_EMAIL = "support@clerical.com";

export default function Support() {
	return (
		<div
			ref={(el) => el?.scrollIntoView()}
			className="mx-auto w-full max-w-5xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14"
		>
			<Seo {...SEO_ROUTE_PROPS["/support"]} />
			<Card className="shadow-sm">
				<CardContent className="p-6 sm:p-8 lg:p-10">
					<div className="space-y-10 [&_a]:font-medium [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_h1]:text-4xl [&_h1]:font-semibold [&_h1]:tracking-tight [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:tracking-tight [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:tracking-tight [&_li]:leading-7 [&_p]:leading-7 [&_section]:space-y-4 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-6">
						<h1>Support</h1>
						<p className="border-b pb-6 text-sm text-muted-foreground">
							We&rsquo;re here to help you get the most out of Clerical.
						</p>

						<section>
							<h2>Contact us</h2>
							<p>
								The fastest way to reach our team is by email at{" "}
								<a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. We read
								every message and respond as quickly as we can.
							</p>
							<p>To help us resolve your issue faster, please include:</p>
							<ul>
								<li>Your firm name and the email address on your account</li>
								<li>
									A description of what you were trying to do and what happened
								</li>
								<li>
									The product or surface you were using (for example, the
									Clerical web app or the Clerical Outlook add-in)
								</li>
								<li>
									Any error messages and, if possible, a screenshot or screen
									recording
								</li>
							</ul>
						</section>

						<section>
							<h2>Response times</h2>
							<p>
								We aim to acknowledge new support requests within one business
								day (Monday&ndash;Friday, excluding U.S. public holidays).
								Urgent issues that affect your firm&rsquo;s ability to use the
								service are prioritized.
							</p>
						</section>

						<section>
							<h2>Clerical for Outlook</h2>
							<p>
								The Clerical add-in adds an AI email assistant directly to
								Outlook. If you run into trouble, these steps resolve the most
								common issues:
							</p>
							<ul>
								<li>
									<strong>Can&rsquo;t sign in:</strong> Select{" "}
									<strong>Continue with Microsoft</strong> in the add-in and
									complete the Microsoft sign-in prompt. The add-in requires a
									Clerical account; if you don&rsquo;t have one yet, contact us
									at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
								</li>
								<li>
									<strong>The add-in doesn&rsquo;t appear:</strong> Make sure
									you&rsquo;re using Outlook on the web, Windows, or Mac with a
									supported account, then open a message and look for{" "}
									<strong>Clerical</strong> on the ribbon. You may need to
									reopen Outlook after installing.
								</li>
								<li>
									<strong>The task pane is blank or won&rsquo;t load:</strong>{" "}
									Close and reopen the task pane, confirm you have an internet
									connection, and try again. If it persists, let us know which
									Outlook client and version you&rsquo;re using.
								</li>
							</ul>
						</section>

						<section>
							<h2>Accounts &amp; billing</h2>
							<p>
								For questions about your account, subscription, or billing,
								email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>{" "}
								from the address associated with your account and our team will
								follow up.
							</p>
						</section>

						<section>
							<h2>Privacy &amp; data</h2>
							<p>
								To learn how we handle your information, see our{" "}
								<a href="/privacy">Privacy Policy</a> and{" "}
								<a href="/terms">Terms of Service</a>. If you have a privacy or
								data request, contact us at{" "}
								<a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
							</p>
						</section>

						<section>
							<h2>Mailing address</h2>
							<p>
								Clerical
								<br />
								2261 Market Street STE 22734
								<br />
								San Francisco, CA 94114
							</p>
						</section>
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
